/*
 *
 * Blogs reducer
 *
 */
import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import {
  processing,
  nextPageProcessing,
  getBlogsResult,
  getBlogsTopicFacetsResult,
} from './actions';

export const initialState = {
  processing: false,
  nextPageProcessing: false,
  data: {},
  filters: [],
  pills: {},
};

const blogsReducer = handleActions(
  {
    [processing](state, action) {
      return update(state, { processing: { $set: action.payload } });
    },
    [nextPageProcessing](state, action) {
      return update(state, { nextPageProcessing: { $set: action.payload } });
    },
    [getBlogsResult](state, action) {
      const { page, error, data, filters, pills } = action.payload;
      if (error) return update(state, { data: {} });

      if (page === 0) {
        return update(state, {
          data: { $set: data },
          filters: { $set: filters },
          pills: { $set: pills },
        });
      }

      return update(state, {
        data: {
          hits: { $push: data.hits },
        },
      });
    },
    [getBlogsTopicFacetsResult](state, action) {
      return update(state, {
        filters: { $set: action.payload },
      });
    },
  },
  initialState,
);

export default blogsReducer;
